// The review period a MOR screen opens on when none is asked for: the previous
// calendar month (the month whose numbers are in), falling back to the newest
// period. `periods` is GET /periods, newest first.
export function defaultPeriod(periods, now = new Date()) {
  if (!periods?.length) return null;
  const prev = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  return periods.find((p) => p.period_year === prev.getFullYear() && p.period_month === prev.getMonth() + 1)
    ?? periods[0];
}
